import { render, staticRenderFns } from "./delayed-production-dialog.vue?vue&type=template&id=0c228d3d&scoped=true&lang=pug&"
import script from "./delayed-production-dialog.vue?vue&type=script&lang=ts&"
export * from "./delayed-production-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./delayed-production-dialog.vue?vue&type=style&index=0&id=0c228d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c228d3d",
  null
  
)

export default component.exports